@if (isMobileView && (pluginInjectorService.widgetService.widgets$ | async)?.length) {
  <swiper-container appSwiper #swiper [config]="swiperConfig" class="swiper-mobile-container" events-prefix="swiper-" init="false" (swiper-slidechange)="onSwiperSlideChange()">
    @for (widget of pluginInjectorService.widgetService.widgets$ | async; track widget; let widgetIndex = $index) {
      <swiper-slide
        (touchstart)="onWidgetHover(widget)"
        #widgetItems
        >
        @if (showWidgetHeader(widget)) {
          <div class="swiper-slide-mobile-header"
            [@hoverAnimation]="widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed || (widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed && widget.isHeaderHovered) ? 'visible' : 'hidden'"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed
            }"
            >
            @if (pluginInjectorService.widgetService.showWidgetTitle(widget)) {
              <span class="swiper-header-title ">{{ widget.name }}{{ widget.extraTitle }}</span>
            }
            <span></span>
            <span>
              <!-- toggle fullscreen mode -->
              @if (!(pluginInjectorService.widgetService.edit$ | async)) {
                <button mat-icon-button class="swiper-icon"
                  (click)="toggleFullscreen(widgetIndex)">
                  <fa-icon class="swiper-fa-icon" [icon]="widgetInFullscreen ? 'compress' : 'expand'"></fa-icon>
                </button>
              }
            </span>
          </div>
        }
        @if (showWidgetHeader(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="swiper-item-content">
          <!-- Render grid item content here -->
          <ng-template
            [appWidgetItem]="widget"></ng-template>
        </div>
      </swiper-slide>
    }
  </swiper-container>
}


@if (!isMobileView) {
  <gridster [options]="pluginInjectorService.widgetService.options" id="grid">
    @for (widget of pluginInjectorService.widgetService.widgets$ | async; track widget; let widgetIndex = $index) {
      <gridster-item
        [item]="widget"
        class="gridster-item"
        (mouseenter)="onWidgetHover(widget)"
        (mouseleave)="onWidgetHoverCancel(widget)"
        #widgetItems>
        @if (showWidgetHeader(widget)) {
          <div class="adx-grid-item-header"
            [@hoverAnimation]="widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed || (widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed && widget.isHeaderHovered) ? 'visible' : 'hidden'"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed
            }"
            >
            @if (pluginInjectorService.widgetService.showWidgetTitle(widget)) {
              <span class="adx-grid-item-header-title ">{{ widget.name }}{{ widget.extraTitle }}</span>
            }
            <span></span>
            <span>
              <!-- toggle fullscreen mode -->
              @if (!(pluginInjectorService.widgetService.edit$ | async)) {
                <button mat-icon-button class="adx-grid-item-header-icon" aria-label="Fullscreen-Button"
                  (click)="toggleFullscreen(widgetIndex)">
                  <fa-icon class="adx-grid-item-fa-icon" [icon]="widgetInFullscreen ? 'compress' : 'expand'"></fa-icon>
                </button>
              }
            </span>
          </div>
        }
        @if (showWidgetHeader(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="adx-grid-item-content">
          <!-- Render grid item content here -->
          <ng-template
            [appWidgetItem]="widget"></ng-template>
        </div>
      </gridster-item>
    }
  </gridster>
}
